import React from 'react';

import { LegacyContentLayoutE } from '@betterment/samba-react';

import ClaimedRewardsCard from './ClaimedRewardsCard';
import InvitationListCard from './InvitationListCard';
import ReferAFriendInvitationCard from './ReferAFriendInvitationCard';
import UnclaimedRewardCard from './UnclaimedRewardCard';

const AvailableRewardsPage: React.FC = () => {
  return (
    <LegacyContentLayoutE
      css={{
        gridTemplateColumns: {
          md: 'minmax(0, 2fr) minmax(0, 1fr)',
          lg: 'minmax(0, 2fr) minmax(0, 1fr)',
        },
      }}
    >
      <LegacyContentLayoutE.Slot1 css={{ display: 'grid', gap: 'space.400' }}>
        <div>
          <UnclaimedRewardCard />
          <ClaimedRewardsCard />
        </div>
      </LegacyContentLayoutE.Slot1>
      <LegacyContentLayoutE.Slot2 css={{ display: 'grid', gap: { base: 'space.200', md: 'space.400' } }}>
        <ReferAFriendInvitationCard />
        <InvitationListCard />
      </LegacyContentLayoutE.Slot2>
    </LegacyContentLayoutE>
  );
};

export default AvailableRewardsPage;
